import { useCallback, useEffect, useState } from 'react';
import { replayOutbox } from '@/lib/api';
import { OUTBOX_CHANGED_EVENT, pendingCount } from '@/lib/offline';

/**
 * Etat de la connexion et file d'attente hors ligne.
 * Connection state and offline outbox.
 */
export function useConnection() {
  const [online, setOnline] = useState(() => navigator.onLine);
  const [pending, setPending] = useState(0);

  const refresh = useCallback(() => {
    void pendingCount().then(setPending);
  }, []);

  useEffect(() => {
    refresh();

    const onOnline = () => {
      setOnline(true);
      // Le retour du reseau declenche le rejeu de la progression en attente.
      void replayOutbox().finally(refresh);
    };
    const onOffline = () => setOnline(false);

    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    window.addEventListener(OUTBOX_CHANGED_EVENT, refresh);

    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
      window.removeEventListener(OUTBOX_CHANGED_EVENT, refresh);
    };
  }, [refresh]);

  return { online, pending };
}
